import React from 'react'

export default function Link(props: React.HTMLProps<HTMLAnchorElement>) {
  const { children, ...attrs } = props
  return <a {...attrs}>{children}</a>
}
